module.exports = __webpack_public_path__ + "static/media/whatsapp.80d1652c.svg";